import { render, staticRenderFns } from "./InputText.global.vue?vue&type=template&id=67b74a9c&scoped=true&"
import script from "./InputText.global.vue?vue&type=script&lang=ts&"
export * from "./InputText.global.vue?vue&type=script&lang=ts&"
import style0 from "./InputText.global.vue?vue&type=style&index=0&id=67b74a9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b74a9c",
  null
  
)

export default component.exports